import { useRecoilValue } from 'recoil';
import dataManagementEntityAtom from 'ProjectManager/DataManagement/Common/recoil/dataManagementEntity/dataManagementEntityAtom';
import dataManagementEntities from 'ProjectManager/DataManagement/Common/constants/dataManagementEntities';
import useUpdateTemplateCustomSubsectionFunction from 'ProjectManager/DataManagement/Questionnaire/components/Subsection/hooks/updateCustomSubsectionFunction/useUpdateTemplateCustomSubsectionFunction';
import useUpdateProjectCustomSubsectionFunction from 'ProjectManager/DataManagement/Questionnaire/components/Subsection/hooks/updateCustomSubsectionFunction/useUpdateProjectCustomSubsectionFunction';

const useUpdateCustomSubsectionFunction = () => {
    const dataManagementEntity = useRecoilValue(dataManagementEntityAtom);

    const dataFromProject = useUpdateProjectCustomSubsectionFunction();
    const dataFromTemplate = useUpdateTemplateCustomSubsectionFunction();

    if (dataManagementEntity === dataManagementEntities.PROJECT) {
        return dataFromProject;
    }

    if (dataManagementEntity === dataManagementEntities.TEMPLATE) {
        return dataFromTemplate;
    }

    return () => {};
};

export default useUpdateCustomSubsectionFunction;
